<div class="ir-modal th-modal">
  <div class="ir-modal--title">
    <div class="ir-line--right">
      <div class="ir-btn th-btn-modal" (click)="selfModal.close()"><i class="material-icons">close</i></div>
    </div>
    <div class="ir-line">
      <div class="ir-line-content">
        <span>{{ upgrade.Name }}</span>
      </div>
    </div>
  </div>
  <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
    <div class="ir-content--modal th-content">
      <div class="ir-plugin th-plugin">
        <div class="ir-line ir-plugin-title">
          <div class="ir-line-content">
            <span> {{ upgrade.Name }} </span>
          </div>
        </div>

        <div class="ir-plugin-content ir-plugin-info th-plugin-info">
          <ng-container *ngFor="let c of config">
            <ng-container *ngTemplateOutlet="row; context: c"></ng-container>
          </ng-container>
        </div>
      </div>
      <div class="ir-txt--right">
        <button *ngIf="upgrade.presentationUrl" (click)="openPresentation()" type="button" class="ir-btn ir-btn--title">
          <span>{{ 'plugins.upgrades.open-presentation' | translate }}</span>
        </button>
      </div>
    </div>
  </div>
</div>

<ng-template #row let-key="key" let-label="label" let-value="valueKey" let-isArray="isValueArray">
  <div class="ir-row" *ngIf="upgrade[key]">
    <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
      <p>
        <span><strong>{{ label | translate }}</strong></span>
      </p>
    </div>
    <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
      <p>
        <span *ngIf="!isArray">{{ value ? (value + upgrade[key] | translate) : upgrade[key] }}</span>
        <span *ngIf="isArray">
          <ng-container *ngFor="let v of upgrade[key]; last as l">
            {{ value ? (value + v | translate) : v }}<ng-container *ngIf="!l">, </ng-container>
          </ng-container>
        </span>
      </p>
    </div>
  </div>
</ng-template>
